import { useEffect, useState } from 'react';

import { subscribeZustandPersistHydration, type ZustandPersistApi } from '~/utils/subscribeZustandPersistHydration';

export type UseZustandPersistHasHydratedResult = {
  /**
   * `true` once a Zustand `persist` store has merged `localStorage` into memory. Use before
   * treating empty slice defaults as real user preferences (e.g. "not watched" vs "not loaded yet").
   */
  hasHydrated: boolean;
};

export const useZustandPersistHasHydrated = (
  persist: ZustandPersistApi | undefined,
): UseZustandPersistHasHydratedResult => {
  const [hasHydrated, setHasHydrated] = useState(() => persist?.hasHydrated() ?? false);

  useEffect(() => {
    if (hasHydrated) {
      return;
    }

    return subscribeZustandPersistHydration(persist, () => {
      setHasHydrated(true);
    });
  }, [hasHydrated, persist]);

  return { hasHydrated };
};
